<div
  *ngIf="gapDayPair$ | async as pair"
  class="header-container flex items-center"
>
  <strong class="flex-1">
    {{ pair.day | moment | amDateFormat: dateFormat }}
  </strong>
  <span>{{ pair.gaps.length }} gaps</span>
</div>
